'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = configureStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = require('redux-logger');

var _middleware = require('redux-saga/lib/internal/middleware');

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// # 构建Redux的状态容器
// 在开发环境时，集成chrome的redux-devtool插件

/**
 * + redux的middleware, 支持action日志打印到console控制台
 * > see: https://www.npmjs.com/package/redux-logger
 */
function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var middlewares = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var reducerFactory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  var callback = arguments[3];

  var rootReducer = reducerFactory();

  var sagaMiddleware = (0, _middleware2.default)();

  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
  var enhancer = composeEnhancers(_redux.applyMiddleware.apply(undefined, [_reduxThunk2.default, sagaMiddleware, (0, _reduxLogger.createLogger)({ level: 'info', collapsed: true })].concat((0, _toConsumableArray3.default)(middlewares))));

  var store = (0, _redux.createStore)(rootReducer, initialState, enhancer);
  store.runSaga = sagaMiddleware.run;
  callback && callback(store);

  return store;
}
/**
 * + redux的middleware，让dispatch支持actionCreator
 * > see: https://www.npmjs.com/package/redux-thunk
 */
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/seed/store/store.dev.js
// module id = 162
// module chunks = 0